/**
 * Bank labels that can actually be auto-submitted to.
 *
 * An organization's `bank_applications` list contains every bank it can
 * generate an application for (Paya, Humboldt, PayArc, Till US, ...), but only
 * these have an auto-submit integration behind them. Anything else picked in
 * the member modal would be silently ignored by the backend, so the picker is
 * filtered down to this list.
 *
 * Must stay in sync with AutoSubmitToBanksService::PROCESSOR_CONFIG.
 */
export const AUTO_SUBMIT_PROCESSOR_LABELS = [
  "ems",
  "ems direct",
  "kurv",
  "priority",
  "north",
  "nab",
  "nuvei",
  "payliance",
];

export const isAutoSubmitProcessor = (option) =>
  AUTO_SUBMIT_PROCESSOR_LABELS.includes(
    String(option?.label ?? "").trim().toLowerCase(),
  );

export const filterAutoSubmitProcessors = (options) =>
  (Array.isArray(options) ? options : []).filter(isAutoSubmitProcessor);

export default filterAutoSubmitProcessors;
